export default __webpack_public_path__ + "static/media/icn-list-white.4a7abf58.svg";